<template>
  <div class="design-tab" v-if="initialized">
    <div class="pa-5">
      <div class="label font-weight-bold">
        {{$t('design_theme_color')}}
      </div>
      <div class="font-weight-light pa-3 pl-0">
        {{$t('design_theme_color_description')}}
      </div>
      <!-- <v-color-picker mode="hexa"  hide-mode-switch show-swatches :swatches="swatches" class="ma-3 no-alpha" v-model="primary"></v-color-picker> -->
      <color-input class="pa-3 pl-0 pb-5" :color.sync="primary"></color-input>

      <div class="label font-weight-bold">
        {{$t('design_text_color')}}
      </div>
      <div class="font-weight-light pa-3 pl-0">
        {{$t('design_text_color_description')}}
      </div>
      <color-input class="pa-3 pl-0 pb-5" :color.sync="text"></color-input>

      <div class="label font-weight-bold">
        {{$t('design_background_color')}}
      </div>
      <div class="font-weight-light pa-3 pl-0">
        {{$t('design_background_color_description')}}
      </div>
      <color-input class="pa-3 pl-0" :color.sync="background"></color-input>

      <div class="label font-weight-bold mt-5">
        {{$t('font')}}:
      </div>
      <div class="font-weight-light pa-3 pl-0">{{$t('design_font_description')}}
      </div>
      <div class="pa-3 pl-0">
        <font-picker
          :value="getThemeDefaultFont"
          :language-fonts="getThemeLanguageFonts"
          :available-languages="overrideAvailableLanguages"
          @update:value="updateDefaultFont"
          @update:language-font="updateLanguageFont"
        ></font-picker>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ColorInput from '@/components/utils/ColorInput'
import FontPicker from '@/components/FontPicker'

export default {
  name: 'DesignTab',
  components: {
    ColorInput,
    FontPicker
  },
  computed: {
    ...mapGetters([
      'initialized',
      'getThemeDefaultFont',
      'getThemeLanguageFonts',
      'enabledLanguages',
      'defaultLanguage'
    ]),
    overrideAvailableLanguages () {
      return (this.enabledLanguages || []).filter(l => l !== this.defaultLanguage)
    },
    primary: {
      get () {
        return this.$store.getters.getTheme.primary
      },

      set (newVal) {
        if (typeof newVal === 'string') {
          this.updateThemeColor(newVal)
        }
      }
    },
    text: {
      get () {
        console.log('getting theme text')
        console.log(this.$store.getters.getTheme)
        return this.$store.getters.getTheme.text ? this.$store.getters.getTheme.text : '#000000'
      },

      set (newVal) {
        if (typeof newVal === 'string') {
          this.updateThemeTextColor(newVal)
        }
      }
    },
    background: {
      get () {
        return this.$store.getters.getTheme.background ? this.$store.getters.getTheme.background : '#FFFFFF'
      },

      set (newVal) {
        if (typeof newVal === 'string') {
          this.updateThemeBackgroundColor(newVal)
        }
      }
    }

  },

  data () {
    return {
      mainColor: '',
      colors: {
        text: '',
        bg: ''
      },
      swatches: [
        ['#2095f2', '#65bbef'],
        ['#ff7f00', '#f43838'],
        ['#51a350', '#333333']
      ]
    }
  },
  methods: {
    ...mapMutations({
      updateThemeColor: 'UPDATE_THEME_COLOR',
      updateThemeTextColor: 'UPDATE_THEME_TEXT_COLOR',
      updateThemeBackgroundColor: 'UPDATE_THEME_BACKGROUND_COLOR',
      updateDefaultFont: 'UPDATE_THEME_DEFAULT_FONT',
      updateLanguageFont: 'UPDATE_THEME_LANGUAGE_FONT'
    })
  },
  created () {

  }
}
</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.design-tab
  height: calc(100% - 52px)
  overflow: auto

.label
  text-transform: uppercase
  color: $label-grey

.no-alpha
  ::v-deep .v-color-picker__controls
    .v-color-picker__preview
      .v-color-picker__sliders
        .v-color-picker__alpha
          display: none
  ::v-deep .v-color-picker__swatch
    width: 33%
    padding: 0 5px
    .v-color-picker__color
      width: 100%

</style>
